var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import { LazyLoader } from '../../../ts/components/LazyLoader';
export class ArchiveProjects extends Component {
    constructor() {
        super('ArchiveProjects', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            // Splash screen
            this.initSplashScreen();
            $('.splash-screen').on('click', (event, button) => {
                this.hideSplashScreen();
            });
            // Hide splash screen on mousewheel event
            $(window).on('wheel', (event, button) => {
                this.hideSplashScreen();
            });
            // Hide splash screen on swipe up event
            $(window).on('touchstart', (event, button) => {
                const touchStartY = event.touches[0].clientY;
                $(window).on('touchmove', (event, button) => {
                    const touchEndY = event.touches[0].clientY;
                    if (touchStartY - touchEndY > 50) {
                        this.hideSplashScreen();
                    }
                });
            });
            // Reset site
            $('.btn-reset-site').on('click', (event, button) => {
                sessionStorage.removeItem('splash-screen-hidden');
            });
            // Project list hover event
            $('.page-archive-project__thumbnail').on('mouseenter', (event, thumbnail) => {
                const title = JSON.parse(`"${thumbnail.data('title')}"`);
                $('.component-header__project-title').text(title);
            }).on('mouseleave', (event, button) => {
                $('.component-header__project-title').text('');
            });
            // Store scroll position
            $(window).on('beforeunload', () => {
                sessionStorage.setItem('scroll-position', String(window.scrollY));
            });
            // Restore scroll position
            const scrollPosition = sessionStorage.getItem('scroll-position');
            if (scrollPosition && sessionStorage.getItem('reset-scroll-position') !== 'true') {
                window.scrollTo(0, Number(scrollPosition));
                sessionStorage.removeItem('reset-scroll-position');
            }
            this.success();
        });
    }
    initSplashScreen() {
        if (sessionStorage.getItem('splash-screen-hidden') === 'true') {
            $('.splash-screen').addClass('is-hidden');
            return;
        }
        else {
            $('body').addClass('has-splash-screen');
        }
        const splashScreen = $('.splash-screen');
        if (splashScreen.length > 0) {
            const images = JSON.parse(atob(splashScreen.data('images')));
            let currentIndex = Math.floor(Math.random() * images.length);
            console.log(images[currentIndex]);
            splashScreen.css('background-image', `url(${LazyLoader.get_src(images[currentIndex])})`);
            splashScreen.addClass('has-transition');
        }
    }
    hideSplashScreen() {
        $('.splash-screen').addClass('is-hidden');
        setTimeout(() => {
            $('body').removeClass('has-splash-screen');
        }, 600);
        sessionStorage.setItem('splash-screen-hidden', 'true');
    }
}
